import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiPost } from "../../../utils/apiRequests";
import {
    GET_GROUPS_AND_TEES_LOADING,
    GET_GROUPS_AND_TEES_ERROR,
    GET_GROUPS_AND_TEES_SUCCESS,
} from "../../../constant/actionTypes";

export const getGroupsAndTees = (payload) => (dispatch) => {
    dispatch({ type: GET_GROUPS_AND_TEES_LOADING });

    apiPost(
        `${ApiEndpoints.league.base}${ApiEndpoints.league.getGroupsTees}`,
        payload,
        (response) => {
            if (response.error == true) {
                dispatch({
                    type: GET_GROUPS_AND_TEES_ERROR,
                    response: response.message,
                });
            } else {
                dispatch({ type: GET_GROUPS_AND_TEES_SUCCESS, response: response });
            }
        },
        (error) => {
            dispatch({ type: GET_GROUPS_AND_TEES_ERROR, response: error });
        }
    );
};
